import { useState, useEffect } from 'react';
import { BounceRightBox } from './BounceRightBox';
import { jsx as _jsx } from "react/jsx-runtime";
const BounceContainer = ({
  children,
  show,
  onMountAnimationEnd,
  onUnmountAnimationEnd
}) => {
  const [shouldRender, setShouldRender] = useState(show);
  useEffect(() => {
    if (show) {
      setShouldRender(true);
    }
  }, [show]);
  const handleUnmountAnimationEnd = () => {
    if (onUnmountAnimationEnd) {
      onUnmountAnimationEnd();
    }
    setShouldRender(false);
  };
  return shouldRender ? /*#__PURE__*/_jsx(BounceRightBox, {
    $show: show,
    onAnimationEnd: () => {
      if (show) {
        if (onMountAnimationEnd) {
          onMountAnimationEnd();
        }
      } else {
        handleUnmountAnimationEnd();
      }
    },
    children: children
  }) : null;
};
export { BounceContainer };